import { Box } from "@mui/material";
import { NavBar } from "../navbar";
import { ContactUsSection } from "../contact";
import {
  BackgroundSection,
  LearningSystemSection,
  AiEnhancedManagementSection,
  GuidelineFlowSection,
  AiCognitiveLimitSection,
  FinalCallToAction,
} from "./components";
import Hero from "../hero";

import { useEffect } from "react";

export default function HereditaryCancerClinic() {
  useEffect(() => {
    document.title = "Hereditary Cancer Clinic";
  }, []);

  return (
    <Box sx={{ margin: 0, padding: 0 }}>
      <NavBar />
      <Hero
        image="/hereditaryclinic.jpg"
        title="Hereditary Cancer Clinic"
        blurb="Our clinic provides comprehensive care for individuals with a family
        history of cancer or known hereditary cancer syndromes. Through
        personalized risk assessment, genetic counseling, and ongoing
        management, we help patients make informed decisions about prevention,
        screening, and treatment."
      />
      <BackgroundSection />
      <LearningSystemSection />
      <AiEnhancedManagementSection />
      <AiCognitiveLimitSection />
      <GuidelineFlowSection />
      <FinalCallToAction />
      <ContactUsSection />
    </Box>
  );
}
